import React, { useEffect, useState } from "react";

function Regattas() {
  const [regattas, setRegattas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIds, setOpenIds] = useState({});

  useEffect(() => {
    fetch("https://wyrowingbackend.onrender.com/regattas")
      .then((res) => res.json())
      .then((data) => {
        setRegattas(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading regattas:", err);
        setLoading(false);
      });
  }, []);

  const toggleOpen = (id) => {
    setOpenIds((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  function formatContent(content) {
    if (!content) return null;
    const lines = content.split("\n").filter((line) => line.trim() !== "");
    return (
      <div>
        {lines.map((line, idx) => {
          // Auto-link URLs
          const parts = line.split(/(https?:\/\/[^\s]+)/g);
          const linkedLine = parts.map((part, i) =>
            /^https?:\/\//.test(part) ? (
              <a
                key={i}
                href={part}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#3a4edc" }}
              >
                {part}
              </a>
            ) : (
              part
            )
          );
          // Bold the first line
          return (
            <div
              key={idx}
              style={
                idx === 0
                  ? { fontWeight: "bold", marginBottom: "0.5em" }
                  : { marginBottom: "0.5em" }
              }
            >
              {linkedLine}
            </div>
          );
        })}
      </div>
    );
  }

  return (
  <div className="centered-page">
      <h2 style={{ textAlign: "left" }}>Regattas</h2>
      <p>
        This is where the rubber meets the road, or more precisely where the
        oars meet the water. These are the current regattas we plan to attend
        annually with some basic details on each. See our calendar for exact
        dates as these may change from year to year. Click a row to expand and
        view the full content.
      </p>
      {loading ? (
        <p>Loading regattas...</p>
      ) : regattas.length === 0 ? (
        <p>No regatta information available at this time.</p>
      ) : (
        <ul style={{ listStyle: "none", padding: 0 }}>
          {regattas
            .slice()
            .sort((a, b) => a.title.localeCompare(b.title))
            .map((item) => (
              <li
                key={item.id}
                style={{
                  marginBottom: "1.5rem",
                  borderLeft: "4px solid #162278",
                  paddingLeft: "1rem",
                  background: "#f8f9fc",
                  borderRadius: "4px",
                  cursor: "pointer",
                  transition: "background 0.2s",
                }}
                onClick={() => toggleOpen(item.id)}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                      flex: 1,
                    }}
                  >
                    {item.title}
                  </span>
                  <span
                    style={{
                      marginLeft: "1rem",
                      fontSize: "1.2rem",
                      color: "#162278",
                    }}
                  >
                    {openIds[item.id] ? "▲" : "▼"}
                  </span>
                </div>
                {openIds[item.id] && (
                  <div
                    style={{
                      margin: "0.75rem 0 0.5rem 0",
                      color: "#333",
                      background: "#f4f6fa",
                      padding: "0.75rem",
                      borderRadius: "6px",
                      fontSize: "1rem",
                      maxHeight: "40em",
                      overflow: "auto",
                    }}
                  >
                    {formatContent(item.content)}
                  </div>
                )}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
}

export default Regattas;
